module.exports = __webpack_public_path__ + "static/media/knowledge-share.4e548187.svg";